import { isFunction } from '.';

function trigger<T extends (...args: any) => any>(fn?: T, ...params: any[]): () => ReturnType<T> {
  return () => isFunction(fn) && fn(...params);
}

export default trigger;
